import SkillItem from "./SkillItem";

const SkillCard = ({
  category,
  idx,
  activeSkill,
  onToggleSkill,
  PreviewCard,
  SkillBar,
  getRelatedContent,
  onLinkClick,
}) => (
  <div className="skills__card">
    <h2>{category.category}</h2>
    <div className="skills__list">
      {category.items.map((skill, index) => {
        const related = getRelatedContent(skill);
        const skillId = `${idx}-${index}`;
        const isActive = activeSkill === skillId;

        return (
          <SkillItem
            key={index}
            skill={skill}
            isActive={isActive}
            onToggle={(e) => {
              if (e) e.stopPropagation();
              onToggleSkill(skillId);
            }}
            related={related}
            PreviewCard={PreviewCard}
            SkillBar={SkillBar}
            index={idx}
            onLinkClick={onLinkClick}
          />
        );
      })}
    </div>
  </div>
);

export default SkillCard;
